
import { defineComponent, computed, PropType } from 'vue'
import { AssetData } from '@bd/admin/types'
import DashboardCarousel from './DashboardCarousel.vue'
import { FiltersState } from '@bd/store-modules/types'

export default defineComponent({
  name: 'CarouselTiles',
  props: {
    value: {
      type: String,
      required: true,
    },
    items: {
      type: Array as PropType<AssetData[]>,
      required: true,
    },
    filtersObject: {
      type: Object as PropType<FiltersState | undefined>,
      required: true,
    },
  },
  emits: ['filter-data'],
  components: { DashboardCarousel },
  setup(props) {
    const activeProperty = computed(() => {
      if (props.filtersObject && props.filtersObject.propertyType) {
        return [props.filtersObject.propertyType]
      } else {
        return []
      }
    })
    return { ...props, activeProperty }
  },
})
